import React from 'react';
import './style.less';

const clsPrefix = 'new-plan-table';
const TableHeader = ({ rowThWidth, colWidth, headerData, rowThText, marginLeft }) => (
  <div className={`${clsPrefix}__fixed-header`} id="new-table-header" style={{ marginLeft }}>
    <div className={`${clsPrefix}__fixed-header-rowhead`} style={{ width: typeof rowThWidth === 'number' ? `${rowThWidth * 100}%` : rowThWidth }}>
      {rowThText || (
        <React.Fragment>
          功能
          <div className="th__inner-seperating-line" />
          版本
        </React.Fragment>
      )}
    </div>
    {headerData.map(item => (
      <div className={`${clsPrefix}__fixed-header-th`} style={{ width: typeof colWidth === 'number' ? `${colWidth * 100}%` : colWidth, borderTop: `4px solid ${item.themeColor}` }}>
        <div>{item.title}</div>
        <a style={{ backgroundColor: item.themeColor }} className="thead-button" href={item.link}>
          {item.btnText}
        </a>
      </div>
    ))}
  </div>
);

export default TableHeader;
